import cx from "classnames"
import type React from "react"

export interface ChipProps {
  onClick?(): void
  text: string
  image: string
  size?: "large"
  disabled?: boolean
  active?: boolean
}

export interface ChipWrapperProps {
  onClick?(): void
  children: React.ReactElement
  disabled?: boolean
  className: string
}

const ChipWrapper = (props: ChipWrapperProps) => {
  if (props.onClick) {
    return (
      <button {...props} type="button" disabled={props.disabled}>
        {props.children}
      </button>
    )
  } else {
    return <div {...props}>{props.children}</div>
  }
}

export const Chip = ({
  onClick,
  text,
  image,
  size,
  disabled,
  active,
}: ChipProps) => {
  return (
    <ChipWrapper
      onClick={onClick}
      disabled={disabled}
      className={cx("cobalt-Chip", {
        "cobalt-Chip--large": size === "large",
        "cobalt-Chip--disabled": disabled,
        "cobalt-Chip--interactive": !!onClick,
        "cobalt-Chip--active": active,
      })}
    >
      <div className="cobalt-Chip__Content">
        <div
          className="cobalt-Chip__Image"
          style={{ backgroundImage: `url(${image})` }}
        />
        <div className="cobalt-Chip__Text">{text}</div>
      </div>
    </ChipWrapper>
  )
}
